import { render, staticRenderFns } from "./member-form-new.vue?vue&type=template&id=8aba95f6"
import script from "./member-form-new.vue?vue&type=script&lang=js"
export * from "./member-form-new.vue?vue&type=script&lang=js"
import style0 from "./member-form-new.vue?vue&type=style&index=0&id=8aba95f6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports